// Configuration utilities for different range filter types

// UTR Range Configuration
export const createUtrConfig = (isPickleball = false, customScaleClassName = null) => {
    const rangeMax = isPickleball ? 10 : 16;

    const customRangeDisplay = (minVal, maxVal) => {
        if (isPickleball) {
            return `${minVal.toFixed(1)} - ${maxVal.toFixed(1)}`;
        }
        return `${minVal.toFixed(2)} - ${maxVal.toFixed(2)}${maxVal === 16 ? '+' : ''}`;
    };

    return {
        rangeMin: 1,
        rangeMax,
        customRangeDisplay,
        scaleData: {
            type: 'numeric',
            start: 1,
            end: rangeMax,
        },
        isHalfSteps: true,
        showMarks: false,
        ...(customScaleClassName ? { scaleClassName: customScaleClassName } : {}),
    };
};

// Prize Money Range Configuration
export const createPrizeMoneyConfig = (prizeMoneyValues, customScaleClassName = null) => {
    const customRangeDisplay = (min, max) => {
        if (min === 1 && max === prizeMoneyValues.length) {
            return 'All';
        }
        if (min === 1) {
            return `${prizeMoneyValues[max - 1].label} and Under`;
        }
        if (max === prizeMoneyValues.length) {
            return `${prizeMoneyValues[min - 1].label} and Over`;
        }
        return `${prizeMoneyValues[min - 1].label} to ${prizeMoneyValues[max - 1].label}`;
    };

    return {
        rangeMin: 1,
        rangeMax: prizeMoneyValues.length,
        customRangeDisplay,
        scaleData: {
            type: 'labels',
            items: prizeMoneyValues,
        },
        isHalfSteps: false,
        showMarks: false,
        ...(customScaleClassName ? { scaleClassName: customScaleClassName } : {}),
    };
};
